import { useState } from "react";

// One logo box for every place a company appears. Tries /api/company-logo/<name>
// (stored Brandfetch bytes, or a Legal 500 corpus logo) and shows the initial
// while loading or when there is none. Wide wordmarks scale to fit; icons fill.
const known = new Map(); // name -> "ok" | "fail", so a missing logo is asked for once

export default function CompanyLogo({
  name,
  size = 36,
  radius = 9,
  bg,
  fg = "var(--on-fill)",
  fallback,
  className,
  style,
}) {
  const key = String(name || "").trim();
  const initialState = () => (key ? known.get(key) || "loading" : "fail");
  const [state, setState] = useState(initialState);
  // A reused instance (list rows, a new page) must re-check when the name changes.
  const [stateKey, setStateKey] = useState(key);
  if (stateKey !== key) {
    setStateKey(key);
    setState(initialState());
  }
  const src = key && state !== "fail" ? `/api/company-logo/${encodeURIComponent(key)}` : null;

  function onLoad(e) {
    const img = e.target;
    const wide = img.naturalWidth > img.naturalHeight * 1.3;
    img.style.objectFit = wide ? "contain" : "cover";
    img.style.padding = wide ? "10%" : "0";
    known.set(key, "ok");
    setState("ok");
  }
  function onError() {
    known.set(key, "fail");
    setState("fail");
  }

  const fontSize = Math.round(size * 0.42 * 10) / 10;
  return (
    <span
      className={className}
      style={{
        position: "relative",
        display: "inline-grid",
        placeItems: "center",
        width: size,
        height: size,
        borderRadius: radius,
        background: state === "ok" ? "var(--on-fill)" : bg || "var(--bg-2)",
        color: fg,
        fontWeight: 700,
        fontSize,
        letterSpacing: "0.02em",
        overflow: "hidden",
        flexShrink: 0,
        ...style,
      }}
    >
      {state !== "ok" && (fallback || key.charAt(0).toUpperCase() || "·")}
      {src && (
        <img
          src={src}
          alt=""
          onLoad={onLoad}
          onError={onError}
          style={{
            position: "absolute",
            inset: 0,
            width: "100%",
            height: "100%",
            boxSizing: "border-box",
            display: state === "ok" ? "block" : "none",
          }}
        />
      )}
    </span>
  );
}
